module.exports = __webpack_public_path__ + "themes/fq/img/frame-center-spec-overlay.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/frame-center-spec-overlay.png
// module id = 3
// module chunks = d-game